<app-toggle-button
  [paths]="getTogglePaths()"
  [navigationCallbacks]="getNavigationCallbacks()"
>
  <ng-container *appToggleOption="'orders'; label: 'Pedidos'">
    <mat-icon fontSet="material-icons-outlined">shopping_bag</mat-icon>
  </ng-container>

  <ng-container *appToggleOption="'messaging'; label: 'Comunicaciones'">
    <mat-icon fontSet="material-icons-outlined">message</mat-icon>
  </ng-container>

  <ng-container *appToggleOption="'services'; label: 'Servicios'">
    <mat-icon fontSet="material-icons-outlined">build</mat-icon>
  </ng-container>

  <ng-container *appToggleOption="'invoices'; label: 'Comprobantes'">
    <mat-icon fontSet="material-icons-outlined">receipt</mat-icon>
  </ng-container>
</app-toggle-button>